import React, { useState } from "react";
import CasallProQuickBuyPopup from './CasallProQuickBuyPopup';
 
const CasallProQuickBuy = props => {
    const [isOpen, setIsOpen] = useState(false);
 
    const togglePopup = () => {
      setIsOpen(!isOpen);
    }

    return (
        <>
            <button className="quickbuy-button" onClick={togglePopup}>
                <img
                    src="/ui/images/shopping-bag-black.svg"
                    alt="Cart icon"
                />
            </button>



            {isOpen && 
                <CasallProQuickBuyPopup 
                    handleClose={togglePopup}
                    productAvailableColors={props.productAvailableColors}
                    gtmTrackingData={props.gtmTrackingData}
                    producttype={props.producttype}
                    productid={props.productid}
                />
            }
        </>
    )
}
 
export default CasallProQuickBuy;